import ProduitsEcoOrganismeController from './produits.eco.organisme.controller';
import template from './produits.eco.organisme.html';

export default {
	bindings: {
		societe: '<',
		form: '<',
		isOpen: '<'
	},
	template,
	controller: ProduitsEcoOrganismeController
};
